<template>
  <div class="flex items-center justify-center min-h-screen bg-grey-lighter sans-serif">
    <div class="w-full max-w-xs">
      <div>
        <h1 class="py-6 text-2xl text-center text-navy">Aggregator Login</h1>
      </div>
      <form class="bg-white shadow-md rounded pt-4 pb-8 mb-4" id="login" v-on:submit.prevent="signIn">
        <div class="mb-4 bg-red px-8 py-3" v-if="loginError">
          <p class="text-sm text-white text-bold">Your email or your password is incorrect</p>
        </div>
        <div class="mb-4 px-8 pt-4">
          <label class="block text-navy-light text-sm mb-2 uppercase" for="email">
            Email
          </label>
          <input class="shadow appearance-none border rounded w-full py-3 px-3 text-navy" v-model="email" id="email"
                 name="email" type="email" placeholder="john@mail.com" v-validate="'required|email'"
                 :class="{'border-red': errors.has('email') }">
          <p class="text-red text-xs italic mt-2" v-show="errors.has('email')">Please enter an email address</p>
        </div>
        <div class="mb-4 px-8">
          <label class="block text-navy-light text-sm mb-2 uppercase" for="password">
            Password
          </label>
          <input class="shadow appearance-none border rounded w-full py-3 px-3 text-navy" v-model="password"
                 id="password" name="password" type="password" placeholder="******************" v-validate="'required'"
                 :class="{'border-red': errors.has('password') }">
          <p class="text-red text-xs italic mt-2" v-show="errors.has('password')">Please enter your password</p>
        </div>
        <div class="flex px-8 mt-3">
          <input type="submit" value="Login"
                 class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded w-full text-lg">
        </div>
        <div class="mt-4 text-center text-xs text-grey">
          <div>
            <p>
              <a @click="goTo('/aggregator/forgot-password')" class="text-blue cursor-pointer">Forgot password?</a>
            </p>
          </div>
          <div class="mt-2">
            <p class="mt-4">Need help?</p>
            <p>(02) 7501 1110 Mon-Fri (8am-5pm AEST)</p>
            <p>s1-brokersupport@moneyme.com.au</p>
          </div>
        </div>
      </form>
      <div class="py-3">
        <p class="text-navy-light text-center text-sm opacity-75">Need help?<br/>(02) 7501 1110 Mon-Fri (8am-5pm AEST)<br/>s1-brokersupport@moneyme.com.au</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AggregatorSignIn',
  metaInfo: {
    title: 'Aggregator Login | SocietyOne Personal Loans',
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      email: '',
      password: '',
      loginError: false,
    };
  },
  methods: {
    async signIn() {
      this.loginError = false;
      const validate = await this.$validator.validateAll();
      if (validate) {
        try {
          const data = await this.$http.post('aggregator/login', {
            email: this.email,
            password: this.password,
          });

          const {token} = data.body;
          if (token) {
            this.$auth.setToken(token);
            this.$router.push('/aggregator/brokers');
          }
        } catch (e) {
          this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Email / Password is incorrect'}`)
          this.loginError = true;
        }
      }
    },
    goTo(page) {
      this.$router.push(page);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorSignIn.vue